interface ActivitySchemaOptions {
	sso?: boolean;
	url: string;
	response: ActivitySchemaOptionsResponse;
	queryParams: ActivitySchemaOptionsQueryParam[];
}

interface ActivitySchemaOptionsResponse {
	key: string;
	name: string;
}

interface ActivitySchemaOptionsQueryParam {
	name: string;
	type: string;
	minLength: number;
}

export enum ActivitySchemaType {
	Text = 'text',
	Memo = 'memo',
	Date = 'date',
	Checkbox = 'checkbox',
	Dropdown = 'dropDown',
}

export class ActivitySchemaModel {
	fields: {
		[key: string]: {
			type: ActivitySchemaType;
			label: string;
			order: number;
			required: boolean;
			readonly?: boolean;
			info?: string;
			options?: ActivitySchemaOptions;
		}
	} = {}

	constructor(a?: Partial<ActivitySchemaModel>) {
		Object.assign(this, a)
	}
}
